import React from 'react'
import { createPortal } from 'react-dom'
import {
  Overlay,
  ModalContainer,
  Header,
  Cancel,
  CloseButton,
  Content,
  Title,
  Description,
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
  ButtonWrapper
} from './CancelConfirmationModal.style'

const CancelConfirmationModal = ({ open, onClose, onConfirm }) => {
  if (!open) return null

  return createPortal(
    <Overlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Header>
          <Cancel onClick={onClose}>Cancel</Cancel>

          <CloseButton onClick={onClose}>✕</CloseButton>
        </Header>

        <Content>
          <Title>Are you sure you want to give up your spot?</Title>

          <Description>
            If you can't make it to this live session, releasing your spot lets
            another member join the practice.
          </Description>
          <ButtonWrapper>
            <ButtonGroup>
              <PrimaryButton onClick={onConfirm}>RELEASE SPOT</PrimaryButton>

              <SecondaryButton onClick={onClose}>KEEP MY SPOT</SecondaryButton>
            </ButtonGroup>
          </ButtonWrapper>
        </Content>
      </ModalContainer>
    </Overlay>,
    document.body
  )
}

export default CancelConfirmationModal
